// extracted by mini-css-extract-plugin
module.exports = {"timer":"Timer_timer__3YVje","title":"Timer_title__2hFtZ"};